import { createShallowStore, createStoreWithSubscribe } from '@frontend/store';

interface AirDemoState {
  isDemoAccount: boolean;
  isDemoDataReady: boolean;

  setIsDemoAccount: (isDemoAccount: boolean) => void;
  setIsDemoDataReady: (isDemoDataReady: boolean) => void;
}

const useAirDemoStore = createStoreWithSubscribe<AirDemoState>(
  (set) => ({
    isDemoAccount: false,
    isDemoDataReady: false,

    setIsDemoAccount: (isDemoAccount) => {
      set({ isDemoAccount });
    },
    setIsDemoDataReady: (isDemoDataReady) => {
      set({ isDemoDataReady });
    },
  }),
  {
    name: 'AirDemoStore',
    trace: true,
  }
);

export const useAirDemoShallowStore = createShallowStore<AirDemoState>(useAirDemoStore);
